// The session cookie the content gate reads (proxy.js). The app keeps the Supabase session in localStorage, which a
// lesson page loading in an iframe cannot send; a cookie goes with every same-origin request, so the gate can check who
// is asking for a lesson, a catalog or a question bank. Set on sign-in and every token refresh, cleared on sign-out.
export const SESSION_COOKIE = 'empirio_session';

/** The Set-Cookie string for this session (null session clears the cookie). */
export function sessionCookie(session, { secure = true, now = Date.now() } = {}) {
  const base = `${SESSION_COOKIE}=`;
  const tail = `; Path=/; SameSite=Lax${secure ? '; Secure' : ''}`;
  const token = session && session.access_token;
  if (!token) return `${base}${tail}; Max-Age=0`;
  const exp = Number(session.expires_at) || 0;                      // seconds since the epoch, from Supabase
  const maxAge = Math.max(60, Math.min(60 * 60 * 24, exp - Math.floor(now / 1000)));
  return `${base}${encodeURIComponent(token)}${tail}; Max-Age=${maxAge}`;
}

/** Writes the cookie for this session into the document (no-op outside a browser). */
export function syncSessionCookie(session) {
  if (typeof document === 'undefined') return;
  try { document.cookie = sessionCookie(session, { secure: typeof location !== 'undefined' && location.protocol === 'https:' }); } catch (e) { /* storage blocked */ }
}
